import { type Utm } from 'core/domain/Utm'
import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { LoadOfferRepository } from '../infra/LoadOfferRepository'

export type ConfirmBookFactoryDependencies = {
  loadOfferRepository: LoadOfferRepository
}

export type ConfirmBookParams = {
  loadOfferUUID: string
  offerUUID: string
  utmParams?: Utm
  config?: { signal: AbortSignal }
}

export function confirmBookFactory({ loadOfferRepository }: ConfirmBookFactoryDependencies) {
  return function confirmBook({ loadOfferUUID, offerUUID, utmParams, config }: ConfirmBookParams) {
    return loadOfferRepository.acceptLoadOffer({ loadOfferUUID, offerUUID, utmParams, config })
  }
}

export function confirmBook(params: ConfirmBookParams) {
  const httpClient = new HttpClient(API_URL)
  const loadOfferRepository = new LoadOfferRepository({ httpClient })
  const newConfirmBook = confirmBookFactory({ loadOfferRepository })

  return newConfirmBook(params)
}
